import React from "react";
import { useMediaQuery } from "react-responsive";
import "./about.css";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const About = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <section className="about page">
      {isMobile ? (
        <>
          <div className="about-container">
            <div className="title">
              <h1>
                <span className="title-word">Who</span> We Are?
              </h1>
            </div>
            <div className="box box-1">
              <div className="box-right">
                <div className="text-box">
                  <h1>
                    Our <span className="title-word">Journey</span> to Build
                    Your Success Story
                  </h1>
                  <div className="image-box">
                    <LazyLoadImage
                      src={require("../../assets/image_fx_ (44).jpg")}
                      alt="About Us Picture"
                      effect="blur"
                    />
                  </div>
                  <p>
                    Founded with the vision of helping startups and small
                    businesses thrive in a competitive digital landscape, CS Lab
                    combines creativity and strategy to deliver tailor-made
                    marketing solutions. Over the years, we’ve worked with
                    businesses of all sizes, guiding them through digital
                    challenges and helping them achieve sustainable growth.
                  </p>
                  <p>
                    Our goal is to empower you to tell your story in the most
                    impactful way possible. By leveraging innovative strategies
                    and a deep understanding of the digital world, we help your
                    brand stand out and connect with your audience effectively.
                  </p>
                </div>
              </div>
            </div>
            <div className="box box-2">
              <div className="box-right">
                <div className="text-box">
                  <h1>
                    Digital Marketing{" "}
                    <span className="title-word">Solutions</span> Built to Fit
                    Your Business
                  </h1>
                  <div className="image-box">
                    <LazyLoadImage
                      src={require("../../assets/about-2.jpg")}
                      alt="About Us Picture"
                      effect="blur"
                    />
                  </div>
                  <p>
                    At CS Lab, our mission is to empower startups and small
                    businesses across the U.S. by delivering digital marketing
                    solutions that are crafted with precision to meet their
                    unique needs. We aim to amplify their brand voice, ensuring
                    it resonates powerfully in a competitive digital landscape.
                  </p>
                  <p>
                    Through innovative strategies and a client-centric approach,
                    we foster sustainable growth and help businesses connect
                    with the right audiences. Whether it's building stronger
                    brand recognition or driving meaningful engagement, our
                    solutions are designed to turn your goals into reality.
                  </p>
                </div>
              </div>
            </div>
            <div className="box box-3">
              <div className="box-right">
                <div className="text-box">
                  <h1>
                    Your Go-to <span className="title-word">Partner</span> for
                    Business Opportunities
                  </h1>
                  <div className="image-box">
                    <LazyLoadImage
                      src={require("../../assets/About-3.jpg")}
                      alt="About Us Picture"
                      effect="blur"
                    />
                  </div>
                  <p>
                    At CS Lab, we strive to be the go-to digital marketing
                    partner for the next generation of business leaders. Our
                    vision is rooted in supporting entrepreneurs and innovators
                    as they navigate the ever-changing digital landscape,
                    empowering them to break boundaries and achieve their goals.
                  </p>
                  <p>
                    By delivering forward-thinking strategies and cutting-edge
                    solutions, we aim to help businesses not only grow but
                    thrive. We see ourselves as more than just a marketing
                    partner—we’re a catalyst for innovation, a guide for growth,
                    and a trusted ally in their journey toward success.
                  </p>
                </div>
              </div>
            </div>
            <div className="end-desc">
              <p>
                At CS Lab, we believe that true success is built on a foundation
                of creativity, integrity, and collaboration. Every project we
                undertake is infused with innovative ideas and a commitment to
                transparency and trust. We pride ourselves on fostering strong
                partnerships with our clients, working hand in hand to align
                goals, navigate challenges, and celebrate achievements together.
              </p>
              <p>
                In today's fast-paced and ever-evolving digital landscape,
                adaptability is key. That’s why we continuously refine our
                strategies to stay ahead of industry trends, ensuring our
                clients always benefit from cutting-edge solutions. We don’t
                just aim to meet expectations—we strive to exceed them.
              </p>
              <p>
                Our results-driven approach is at the heart of everything we do.
                By focusing on delivering impactful solutions, we are dedicated
                to fueling business growth, creating meaningful impact, and
                driving long-term success for every client we serve. At CS Lab,
                your vision becomes our mission.
              </p>
            </div>
            <div className="cta">
              <h1>Let's Turn Your Vision Into Reality!</h1>
              <Link to="/about" onClick={handleClick}>
                <button className="btn">Contact Us Now</button>
              </Link>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="about-container">
            <div className="title">
              <h1>
                <span className="title-word">Who</span> We Are?
              </h1>
            </div>
            <div className="box box-1">
              <div className="box-left">
                <div className="image-box">
                  <LazyLoadImage
                    src={require("../../assets/image_fx_ (44).jpg")}
                    alt="About Us Picture"
                    effect="blur"
                  />{" "}
                </div>
              </div>
              <div className="box-right">
                <div className="text-box">
                  <h1>
                    Our <span className="title-word">Journey</span> to Build
                    Your Success Story
                  </h1>
                  <p>
                    Founded with the vision of helping startups and small
                    businesses thrive in a competitive digital landscape, CS Lab
                    combines creativity and strategy to deliver tailor-made
                    marketing solutions. Over the years, we’ve worked with
                    businesses of all sizes, guiding them through digital
                    challenges and helping them achieve sustainable growth.
                  </p>
                  <p>
                    Our goal is to empower you to tell your story in the most
                    impactful way possible. By leveraging innovative strategies
                    and a deep understanding of the digital world, we help your
                    brand stand out and connect with your audience effectively.
                  </p>
                </div>
              </div>
            </div>
            <div className="box box-2">
              <div className="box-right">
                <div className="text-box">
                  <h1>
                    Digital Marketing{" "}
                    <span className="title-word">Solutions</span> Built to Fit
                    Your Business
                  </h1>
                  <p>
                    At CS Lab, our mission is to empower startups and small
                    businesses across the U.S. by delivering digital marketing
                    solutions that are crafted with precision to meet their
                    unique needs. We aim to amplify their brand voice, ensuring
                    it resonates powerfully in a competitive digital landscape.
                  </p>
                  <p>
                    Through innovative strategies and a client-centric approach,
                    we foster sustainable growth and help businesses connect
                    with the right audiences. Whether it's building stronger
                    brand recognition or driving meaningful engagement, our
                    solutions are designed to turn your goals into reality.
                  </p>
                </div>
              </div>
              <div className="box-left">
                <div className="image-box">
                  <LazyLoadImage
                    src={require("../../assets/about-2.jpg")}
                    alt="About Us Picture"
                    effect="blur"
                  />
                </div>
              </div>
            </div>
            <div className="box box-3">
              <div className="box-left">
                <div className="image-box">
                  <LazyLoadImage
                    src={require("../../assets/About-3.jpg")}
                    alt="About Us Picture"
                    effect="blur"
                  />
                </div>
              </div>
              <div className="box-right">
                <div className="text-box">
                  <h1>
                    Your Go-to <span className="title-word">Partner</span> for
                    Business Opportunities
                  </h1>
                  <p>
                    At CS Lab, we strive to be the go-to digital marketing
                    partner for the next generation of business leaders. Our
                    vision is rooted in supporting entrepreneurs and innovators
                    as they navigate the ever-changing digital landscape,
                    empowering them to break boundaries and achieve their goals.
                  </p>
                  <p>
                    By delivering forward-thinking strategies and cutting-edge
                    solutions, we aim to help businesses not only grow but
                    thrive. We see ourselves as more than just a marketing
                    partner—we’re a catalyst for innovation, a guide for growth,
                    and a trusted ally in their journey toward success.
                  </p>
                </div>
              </div>
            </div>
            <div className="end-desc">
              <p>
                At CS Lab, we believe that true success is built on a foundation
                of creativity, integrity, and collaboration. Every project we
                undertake is infused with innovative ideas and a commitment to
                transparency and trust. We pride ourselves on fostering strong
                partnerships with our clients, working hand in hand to align
                goals, navigate challenges, and celebrate achievements together.
              </p>
              <p>
                In today's fast-paced and ever-evolving digital landscape,
                adaptability is key. That’s why we continuously refine our
                strategies to stay ahead of industry trends, ensuring our
                clients always benefit from cutting-edge solutions. We don’t
                just aim to meet expectations—we strive to exceed them.
              </p>
              <p>
                Our results-driven approach is at the heart of everything we do.
                By focusing on delivering impactful solutions, we are dedicated
                to fueling business growth, creating meaningful impact, and
                driving long-term success for every client we serve. At CS Lab,
                your vision becomes our mission.
              </p>
            </div>
            <div className="cta">
              <h1>Let's Turn Your Vision Into Reality!</h1>
              <Link to="/contact" onClick={handleClick}>
                <button className="btn">Contact Us Now</button>
              </Link>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default About;
